// extracted by mini-css-extract-plugin
module.exports = {"input":"styles-module--input--2oj9v","sent":"styles-module--sent--2PFuW"};